<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    if (localStorage.getItem('tokenWeb')){
      this.$store.commit('SET_User',JSON.parse(localStorage.getItem('user')))
      this.$store.dispatch('GetInfo').then(res=>{

      })
    }
  },
}
</script>

<style lang="less">
  @import "../src/components/css/public.less";
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: black;
    width: 100%;
    height: 100%;
  }
  body{
    width: 100%;
    height: 100%;
  }
  html{
    width: 100%;
    height: 100%;
  }
  /*上传头像样式*/
  .avatar-uploader .el-upload {
    border: 1px dashed #ddd;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue